import { render, staticRenderFns } from "./Report-student.vue?vue&type=template&id=78133f19"
import script from "./Report-student.vue?vue&type=script&lang=js"
export * from "./Report-student.vue?vue&type=script&lang=js"
import style0 from "./Report-student.vue?vue&type=style&index=0&id=78133f19&prod&lang=scss"
import style1 from "./Report-student.vue?vue&type=style&index=1&id=78133f19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports